'use strict';

module.exports = {
  CREATE_CUSTOMER_ARRIVAL: 'create-customer-arrival',
};
